import React, { useState } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';

function MostQuestioned() {

    const [expandedIndexes, setExpandedIndexes] = useState({});

    // Function to toggle the visibility of an answer for a specific question
    const toggleAnswer = (index) => {
        setExpandedIndexes((prevState) => ({
            ...prevState,
            [index]: !prevState[index] // Toggle the visibility
        }));
    };

    const manualIndex = [1, 2, 3, 4, 5];


    return (
        <>
            <div className="flex flex-col mt-20">
                <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                    الأسئلة الأكثر شيوعًا
                </div>
                <div className="flex flex-col justify-center px-4 py-5 mt-12 w-full bg-white rounded-2xl max-md:mt-10 max-md:max-w-full">
                    <div className="flex gap-5 justify-between w-full rounded-none max-md:flex-wrap max-md:max-w-full">
                        <div className="flex items-center gap-2 max-md:flex-wrap max-md:max-w-full">
                            <LazyLoadImage loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/6e46e9a087bcdbff985f89bd5f6c19fc1853ba2112f213f0ba23516d1bf137ae?" alt="Search Icon" className="w-9 aspect-square" />
                            <input type="text" className="outline-none flex-grow py-2.5 px-4 text-xl font-light text-right text-black rounded-lg max-md:max-w-full" placeholder="أبحث عن الموضوع" />
                        </div>
                        <button className="flex justify-center items-center px-5 py-2.5 text-base font-bold text-center text-white whitespace-nowrap bg-blue-900 rounded-lg shadow-sm aspect-[1.51]">
                            بحث
                        </button>
                    </div>

                </div>
                <div className="mt-12 w-full max-md:mt-10 max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                        <div className="flex flex-col ml-5 w-[24%] max-md:ml-0 max-md:w-full">
                            <ul className="flex flex-col self-stretch mx-auto w-full text-lg font-medium leading-6 text-right bg-white text-black rounded-2xl border border-solid shadow-sm border-[color:var(--Gray-300,#D0D5DD)] max-md:mt-6">

                                <li className="flex gap-5  py-2.5 pr-4 pl-20 font-bold text-blue-900 whitespace-nowrap bg-amber-300 max-md:pl-5 rounded-2xl">
                                    <LazyLoadImage
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/ba3661d9409bbf05a0029455647f7d2d639b3c8641e206475d92444c58f9fdb6?"
                                        className="aspect-square w-[54px]"
                                    />
                                    <div className="my-auto">الزكـــــــاة</div>
                                </li>

                            </ul>
                        </div>
                        <div className="flex flex-col w-[76%] max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col grow text-right text-neutral-900 max-md:mt-6 max-md:max-w-full gap-5">
                                {manualIndex.map((index) => (
                                    <div key={index} className="flex gap-0 justify-between px-8 py-5 text-black bg-white rounded-2xl border-2 border-indigo-800 border-solid max-md:flex-wrap max-md:px-5 max-md:max-w-full">
                                        <div className="flex flex-col flex-1 py-2.5 max-md:max-w-full">
                                            <div className="text-xl font-bold leading-7 max-md:max-w-full">
                                                ما الذي أحسبه في ثروتي/صافي أصولي للزكاة؟
                                            </div>
                                            {expandedIndexes[index] &&
                                                <div className="mt-3 text-base leading-6 max-md:max-w-full">
                                                    يمكن حساب ثروتك أو أصولك الصافية على أنها الأصول السائلة
                                                    التي تمتلكها، وتطرح منها الالتزامات قصيرة الأجل التي عليك.
                                                    <br />
                                                    والأصول السائلة هي تلك التي يمكن تحويلها إلى نقد بسهولة
                                                    كبيرة. وتشمل الالتزامات قصيرة الأجل الفواتير، والإيجار،
                                                    والسُّلف الشخصية، وديون بطاقات الائتمان. ويتفق معظم العلماء
                                                    على أن أي قرض عقاري مستحق للمصرف عليك، ينبغي عدم إدراجه في
                                                    هذا الحساب.
                                                    <br />
                                                    <br />
                                                    <span className="font-bold">
                                                        وإليك ما يجب تضمينه في أصولك:
                                                    </span>
                                                    <ul>
                                                        <li>المبالغ النقدية في البنك والمنزل</li>
                                                        <li>
                                                            النقد المدخر لأي أغراض خاصة، على سبيل المثال الزفاف،
                                                            الحج، شراء سيارة، إلخ.
                                                        </li>
                                                        <li>قيمة الذهب والفضة التي تملكها</li>
                                                        <li>قيمة الأسهم بسعر السوق</li>
                                                        <li>
                                                            الأموال المستحقة لك (مثل الديون التي لك على الناس)،
                                                            والتي من المرجح أن يتم سدادها لك
                                                        </li>
                                                        <li>
                                                            إذا كنت تمتلك شركة، فقيمة الميزانية العمومية للأسهم التي
                                                            تمتلكها.
                                                        </li>
                                                        <li>إذا كنت تملك عقارات، فكل دخل من الإيجار قد ادخرته</li>
                                                    </ul>
                                                    <br />
                                                    لا تحتاج إلى حساب قيمة منزلك أو الأرض كجزء من الأصول الواجبة
                                                    للزكاة. ولا تحتاج أيضًا إلى تضمين أي ممتلكات شخصية كالسيارة
                                                    أو الملابس أو الأجهزة المنزلية، وما إلى ذلك كجزء من أصولك.
                                                    <br />
                                                    إذا كنت تمتلك عقارات تستثمرها (للشراء/للتأجير)، فسيكون أي
                                                    دخل تدخره من الإيجار جزءًا من الأصول التي تحتسب للزكاة، ولكن
                                                    لا يتم تضمين قيمة محفظة الاستثمار العقاري كجزء من أصولك في
                                                    حساب الزكاة.
                                                    <br />
                                                    إذا كنت تنوي بيع أي عقار استثماري في الفترة التي يقع بها
                                                    تاريخ استحقاق الزكاة، فيجب تضمين الربح المتوقع كجزء من
                                                    أصولك.
                                                </div>
                                            }
                                        </div>
                                        <LazyLoadImage
                                            onClick={() => toggleAnswer(index)}
                                            src={expandedIndexes[index]
                                                ? "https://cdn.builder.io/api/v1/image/assets/TEMP/ff7b3593438f82d47e600a8bca1e11a5f8ef25af095dec220b4419850becf9cb?"
                                                : "https://cdn.builder.io/api/v1/image/assets/TEMP/2056139a267ea2899a2fb3cf4a5c3b5915a1690a3de5711b07427b66dcfdc004?"}
                                            className="self-start w-6 aspect-square"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default MostQuestioned